import { projectFirestore } from '../../firebase/config'
import { useEffect, useState } from 'react'

import ProjectList from '../../components/ProjectList'

// styles
import '../journal/Journal.css'
import { useTheme } from '../../hooks/useTheme'

export default function Lessons() {
    const [data, setData] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(false)
    const { mode } = useTheme()

    useEffect(() => {
        setIsPending(true)
        projectFirestore.collection("projects").orderBy("order", "asc").get().then((snapshot)=> {
         if (snapshot.empty) {
             setError('No journals to load')
             setIsPending(false)
         } else {
             let results = []
             snapshot.docs.forEach(doc => {
                 results.push({ id: doc.id, ...doc.data() })
             })
             setData(results)
             setIsPending(false)
         }
        }).catch(err => {
            setError(err.message)
            setIsPending(false)
        })
    }, [])

    return (
        <div className={`layout-journal ${mode}`}>
            <div className='header'>
                <h1>Portfolio</h1>
                <p className='about'>Come view some websites and projects I have built. Sites built using WordPress, React, and more.</p>
            </div>
            {error && <p className='error'>{error}</p>}
            {isPending && <p className='loading'>Loading...</p>}
            {data && <ProjectList projects={data}/>}
        </div>
    )
}